<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Sample Category'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-hashtag"></p-inputicon>
                <input
                        pInputText
                        id="sample-category-name"
                        [(ngModel)]="this.sampleCategory.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Sample Category Name"
                />
            </p-iconfield>
            <label for="sample-category-name">Sample Category Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-barcode"></p-inputicon>
                <input
                        pInputText
                        id="tariff-code"
                        [(ngModel)]="this.sampleCategory.tariffCode"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Tariff Code"
                />
            </p-iconfield>
            <label for="tariff-code">Tariff Code</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-inputnumber [(ngModel)]="this.sampleCategory.defaultWeight" suffix="g"
                           class="w-full"
                           inputId="default-weight"></p-inputnumber>
            <label for="default-weight">Default weight</label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>

    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveSampleCategory()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>